/**
 * Улика со страницы конторы: то, чем ловят враньё ленты.
 *
 * Полный innerText, куки и HTML в шкаф не кладём: это свалка, не доказательство.
 * Нужны хост, наш кэф, ближайшее число, попали ли имена и исход, и короткий
 * кусок текста вокруг кэфа. Снимать в момент проверки, не с каждой вкладки.
 */

/** Длиннее — уже простыня, не улика. */
export const AROUND_MAX = 240;

export type ClipState = 'match' | 'moved' | 'unreadable' | 'absent';

export type PageClip = {
  venue: string;
  host: string;
  ours: string;
  state: ClipState;
  /** Строка, не float: в шкаф деньги так не кладут. */
  closest: string | null;
  who: string[];
  whoHit: boolean;
  side: string;
  sideHit: boolean;
  around: string;
  /** Ячейка на месте, линия снята. Кэф в closest часто ещё жив. */
  suspended?: boolean;
  /**
   * Ячейка / ask, не ближайшее число на простыне главной.
   * Без этого стол навсегда сажает чужой кэф с лобби (PAGE_FRESH = ∞).
   */
  trusted?: boolean;
};

const SECRET =
  /(?:sessionid|sid|csrf|token|auth|jwt|bearer|cookie)\s*[=:]\s*\S+|[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{10,}|\b[a-fA-F0-9]{32,}\b|\b[A-Za-z0-9+/]{40,}={0,2}\b/gi;

export function scrub(text: string): string {
  return text.replace(SECRET, '[cut]');
}

export function hostOf(url: string | null | undefined): string {
  if (typeof url !== 'string' || url === '') return '';
  try {
    return new URL(url).hostname.toLowerCase().replace(/^www\./, '').slice(0, 80);
  } catch {
    return '';
  }
}

export function oddsText(n: number, ours: string): string {
  const dot = ours.search(/[.,]/);
  const places = dot < 0 ? 2 : Math.min(3, ours.length - dot - 1) || 2;
  return (Math.round(n * 10 ** places) / 10 ** places).toFixed(places);
}

export function aroundOf(text: string, needles: readonly string[]): string {
  const clean = scrub(text.replace(/\s+/g, ' ').trim());
  for (const needle of needles) {
    if (!needle) continue;
    const at = clean.toLowerCase().indexOf(needle.toLowerCase());
    if (at < 0) continue;
    const mid = at + needle.length / 2;
    const start = Math.max(0, Math.round(mid - AROUND_MAX / 2));
    return clean.slice(start, start + AROUND_MAX);
  }
  return clean.slice(0, AROUND_MAX);
}

function tokenHit(needle: string, hay: string): boolean {
  const n = needle.trim();
  if (n.length < 3) return false;
  return hay.toLowerCase().includes(n.toLowerCase());
}

export function whoHitOf(who: readonly string[], text: string): boolean {
  const names = who.map((one) => one.trim()).filter((one) => one.length >= 3);
  if (names.length === 0) return true;
  return names.some((one) => tokenHit(one, text));
}

export function sideHitOf(side: string, text: string): boolean {
  const n = side.trim();
  if (n.length < 4) return true;
  return text.toLowerCase().includes(n.toLowerCase());
}

export function clipOf(input: {
  venue: string;
  url?: string | null;
  odds: string;
  who?: readonly string[];
  side?: string;
  text: string | null;
  state: ClipState;
  closest: number | null;
  suspended?: boolean;
  trusted?: boolean;
}): PageClip {
  const who = (input.who ?? [])
    .filter((one): one is string => typeof one === 'string' && one.trim() !== '')
    .slice(0, 8)
    .map((one) => one.trim().slice(0, 80));
  const side = (input.side ?? '').trim().slice(0, 120);
  const closest =
    input.closest === null || !Number.isFinite(input.closest)
      ? null
      : oddsText(input.closest, input.odds);
  const text = input.text;
  const around =
    typeof text === 'string' && text !== ''
      ? aroundOf(text, [input.odds, input.odds.replace('.', ','), closest ?? ''])
      : '';
  const hay = typeof text === 'string' ? text : '';
  return {
    venue: input.venue.slice(0, 40),
    host: hostOf(input.url),
    ours: input.odds,
    state: input.state,
    closest,
    who,
    whoHit: hay === '' ? false : whoHitOf(who, hay),
    side,
    sideHit: hay === '' ? false : sideHitOf(side, hay),
    around,
    ...(input.suspended === true ? { suspended: true } : {}),
    ...(input.trusted === true ? { trusted: true } : input.trusted === false ? { trusted: false } : {}),
  };
}

export function parseClip(raw: unknown): PageClip | null {
  if (typeof raw !== 'object' || raw === null) return null;
  const one = raw as Record<string, unknown>;
  const venue = one.venue;
  const host = one.host;
  const ours = one.ours;
  const state = one.state;
  const closest = one.closest;
  const who = one.who;
  const side = one.side;
  const around = one.around;
  if (typeof venue !== 'string' || venue === '') return null;
  if (typeof host !== 'string') return null;
  if (typeof ours !== 'string' || !/^\d+(\.\d+)?$/.test(ours)) return null;
  if (state !== 'match' && state !== 'moved' && state !== 'unreadable' && state !== 'absent') {
    return null;
  }
  if (closest !== null && (typeof closest !== 'string' || !/^\d+(\.\d+)?$/.test(closest))) {
    return null;
  }
  if (!Array.isArray(who) || who.some((name) => typeof name !== 'string')) return null;
  if (typeof side !== 'string') return null;
  if (typeof around !== 'string' || around.length > AROUND_MAX) return null;
  if (typeof one.whoHit !== 'boolean' || typeof one.sideHit !== 'boolean') return null;
  return {
    venue: venue.slice(0, 40),
    host: host.slice(0, 80),
    ours,
    state,
    closest,
    who: who.filter((name): name is string => typeof name === 'string').slice(0, 8),
    whoHit: one.whoHit,
    side: side.slice(0, 120),
    sideHit: one.sideHit,
    around: scrub(around).slice(0, AROUND_MAX),
    ...(one.suspended === true ? { suspended: true } : {}),
    ...(one.trusted === true ? { trusted: true } : one.trusted === false ? { trusted: false } : {}),
  };
}

export function parseClips(raw: unknown): PageClip[] | null {
  if (!Array.isArray(raw) || raw.length === 0 || raw.length > 8) return null;
  const out: PageClip[] = [];
  for (const one of raw) {
    const clip = parseClip(one);
    if (clip === null) return null;
    out.push(clip);
  }
  return out;
}
